import {
  Button,
  Card,
  Col,
  Dropdown,
  Menu,
  Pagination,
  Row,
  Select,
  Space,
  Tooltip,
  Typography,
} from "antd";
import React, { useState, useEffect } from "react";
import "./spotlight.scss";
import Sidenav from "../../component/sidenav";
import { Meta } from "antd/lib/list/Item";
import { DownOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

const items = [
  {
    key: "1",
    label: "Item 1",
  },
  {
    key: "2",
    label: "Item 2",
  },
  {
    key: "3",
    label: "Item 3",
  },
];
function SpotLight() {
  const query = new URLSearchParams(window.location.search);
  const token = query.get("token");

  const [objectiveUserList, setObjectiveUserList] = useState();
  const [objectiveShow, setObjectiveShow] = useState(false);
  const [objectiveLossableList, setObjectiveLossableList] = useState();
  const [lossableobjectiveShow, setLossableObjectiveShow] = useState(false);
  const [spotLight, setSpotLight] = useState({
    learningIndex: 0,
    rocketship: 0,
    riskIndex: 0,
    lossableBet: 0,
    connectednessIndex: 0,
    energyIndex: 0,
  });
  const [objectivesList, setObjectivesList] = useState([]);
  const [successIndicator, setSuccessIndicator] = useState({
    successIndicator: "0%",
  });

  const fetchSpotlight = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/resilience-analytics?token=${token}`
    )
      .then((res) => res.json())
      .then((response) => {
        if (response?.statusCode && response?.statusCode === 402) {
          window.location.href = `/subscriptions?token=${token}`;
        } else if ("rocketship" in response) {
          setSpotLight(response);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
  const getObjectives = () => {
    fetch(`${process.env.REACT_APP_API_URL}/objectives?token=${token}`)
      .then((res) => res.json())
      .then((response) => {
        if (response.data) {
          setObjectivesList(response.data);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const getObjective = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/objective?token=${token}&rocketship=true`
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.data) {
          setObjectiveUserList(response.data);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const getlossablObjective = () => {
    fetch(
      `${process.env.REACT_APP_API_URL}/objective?token=${token}&lossableBet=true`
    )
      .then((res) => res.json())
      .then((response) => {
        if (response.data) {
          setObjectiveLossableList(response.data);
        }
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  useEffect(() => {
    fetchSpotlight();
    getObjectives();
    getObjective();
    getlossablObjective();
  }, []);

  const fetchSuccessIndicator = (objectiveId) => {
    fetch(
      `${process.env.REACT_APP_API_URL}/success?objectiveId=${objectiveId}&token=${token}`
    )
      .then((res) => res.json())
      .then((response) => {
        setSuccessIndicator(response);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const handleRocketClick = (data) => {
    if (data === "Rocketships") {
      setObjectiveShow(!objectiveShow);
    }
    if (data === "Pilots / Losable Bets") {
      setLossableObjectiveShow(!lossableobjectiveShow);
    }
  };

  const cardData = (title, tooltipMessage, index, indexImg) => {
    let prop = {};
    if (title === "Success Indicator") {
      prop = {
        ...prop,
        sm: 9,
        xs: 24,
      };
    } else {
      prop = {
        ...prop,
        sm: 12,
        lg: 8,
        md: 12,
        xs: 24,
      };
    }
    return (
      <>
        <Col className="p-3" {...prop}>
          <Card
            onClick={() => handleRocketClick(title)}
            className={`p-3 ${
              title === "Rocketships" || title === "Pilots / Losable Bets"
                ? "objective-card"
                : ""
            }`}
            hoverable
            bordered
            style={{ borderRadius: 20 }}
          >
            <div className="header-card align-items-start">
              <Tooltip
                title={tooltipMessage}
                color={"txt-primary"}
                placement="top"
              >
                <InfoCircleOutlined
                  style={{
                    position: "absolute",
                    right: 1,
                    top: 1,
                    margin: 16,
                    width: 16,
                    height: 16,
                    fontSize: 16,
                    color: "rgb(159 159 159)",
                  }}
                />
              </Tooltip>
              <p className="text-capitalize f-16 f-w-600 txt-text-1 pb-2 mb-1">
                {title}
              </p>
              <p className="text-capitalize f-32 f-w-800 txt-primary">
                {index === "NaN" ? "0%" : index}{" "}
              </p>
            </div>
            <span
              className={`${
                title === "Energy Index"
                  ? index >= "90"
                    ? "sunny-img"
                    : index > "50"
                    ? "moderate-img"
                    : "gloomy-img"
                  : `${indexImg}`
              } card-img`}
            ></span>
          </Card>
          {objectiveShow && title === "Rocketships" && (
            <div className="object-hover">
              {objectiveUserList?.objectives.length > 0 &&
                objectiveUserList.objectives.map((ObjectiveNames, index) => {
                  if (index < 5) {
                    return <li key={index}>{ObjectiveNames.name}</li>;
                  }
                  return;
                })}
              <div className="d-flex justify-content-center">
                <Link
                  to={`/?token=${token}&rocketship=true`}
                  className="objective-link"
                  data-telemetry="Rocketships: View All Objective"
                >
                  View All Objective
                </Link>
              </div>
            </div>
          )}
          {lossableobjectiveShow && title === "Pilots / Losable Bets" && (
            <div className="object-hover">
              {objectiveLossableList?.objectives.length > 0 &&
                objectiveLossableList.objectives.map(
                  (ObjectiveNames, index) => {
                    if (index < 5) {
                      return <li key={index}>{ObjectiveNames.name}</li>;
                    }
                    return;
                  }
                )}
              <div className="d-flex justify-content-center">
                <Link
                  to={`/?token=${token}&lossableBet=true`}
                  className="objective-link"
                  data-telemetry="Pilots / Losable Bets: View All Objective"
                >
                  View All Objective
                </Link>
              </div>
            </div>
          )}
        </Col>
      </>
    );
  };

  return (
    <div className="d-flex">
      <Sidenav />
      <div className="flex-1 spotlight p-4">
        <p className="f-24 f-w-600 txt-text-1">Spot Light</p>
        <Row gutter={20} className="mb-4">
          {cardData(
            "Rocketships",
            "Number of Objectives whose outcomes are outperforming timelines by > 20%",
            spotLight.rocketship,
            "rocket-img"
          )}
          {cardData(
            "Learning Index",
            "Number of closed Objectives with Learnings captured",
            spotLight.learningIndex,
            "index-img"
          )}
          {/* {cardData(
            "Risk Index",
            "Objectives without Optionality for their KeyResults",
            spotLight.riskIndex,
            "risk-img"
          )} */}
          {cardData(
            "Pilots / Losable Bets",
            "Total delivered to the Budget requested for individual KeyResults",
            spotLight.lossableBet,
            "bet-img"
          )}
          {/* {cardData(
            "Connectedness Index",
            "Shows the ratio of messages in Humanize channel to the messages in the OKR channels",
            spotLight.connectednessIndex,
            "engagment-img"
          )} */}
          {cardData(
            "Energy Index",
            "Overall energy of your team",
            spotLight.energyIndex,
            "energy-img"
          )}
        </Row>
        <div className="mt-5">
          <p className="f-24 f-w-600 txt-text-1">AI Success Indicator</p>
          <div className="max-w-500 spotlight-select">
            <Select
              className="w-100 mt-3"
              placeholder="Select an Objective"
              onChange={(val) => fetchSuccessIndicator(val)}
              data-telemetry="Select an Objective to see AI Success Indicator"
            >
              {objectivesList.map((d, index) => (
                <Select.Option key={index} value={d._id}>
                  {d.title}
                </Select.Option>
              ))}
            </Select>
          </div>
          <Row gutter={20} className="mt-3">
            {cardData(
              "Success Indicator",
              "Our AI uses progress, confidence, energy and optionality data to predict success!",
              successIndicator.successIndicator,
              "success-img"
            )}
          </Row>
        </div>
      </div>
    </div>
  );
}

export default SpotLight;
